import { useLocation } from "react-router-dom";
import { useReadLocalStorage } from "usehooks-ts";

import {
  computeIsFeatureFlagEnabled,
  FEATURE_FLAGS,
  POWERTOOLS_STORAGE_KEY,
} from "src/router/featureFlags";

// Identity deserializer: the stored value is a plain string flag, not JSON
const deserializer = (value: string): string => value;

/**
 * Render-safe replacement for `isFeatureFlagEnabled`: reads the URL from
 * router context and localStorage via `useReadLocalStorage`, so the value
 * is pure during render (React Compiler compatible) and updates on
 * navigation.
 */
export const useIsFeatureFlagEnabled = (
  flag: FEATURE_FLAGS | string,
): boolean => {
  const { pathname, search } = useLocation();
  const powertoolsStorageValue = useReadLocalStorage<string>(
    POWERTOOLS_STORAGE_KEY,
    { deserializer },
  );

  return computeIsFeatureFlagEnabled(flag, {
    pathname,
    search,
    hasPowertoolsStorageOverride: Boolean(powertoolsStorageValue),
  });
};
